let baseUrl = "";
let urlFile = "";
if (process.env.NODE_ENV === "production") {
  baseUrl = "https://back-qsahara.frb.io/api";
  urlFile = "https://back-qsahara.frb.io";

    //baseUrl = "https://back-qsahara.frb.io/api";
    //urlFile = "https://back-qsahara.frb.io";
}
//if (process.env.NODE_ENV === "production"){baseUrl = "https://demo-tx.frb.io/api"; urlFile = "https://demo-tx.objects.frb.io" }
else {
  //baseUrl = "https://api-npm qsahara.frb.io/api";
  baseUrl = "http://127.0.0.1:8000/api";
  urlFile = "http://127.0.0.1:8000";
}

const Constant = {
  API_URL: baseUrl,
  URL_FILE: urlFile
};

export default Constant;
